interface SiteIdentifier {
  url: string;
  identifier: string;
}

const siteIdentifiers: SiteIdentifier[] = [
  {
    url: 'book.marriottvacationclub.me',
    identifier: 'ME',
  },
  {
    url: 'book.marriottvacationclub.asia',
    identifier: 'Asia',
  },
  {
    url: 'localhost',
    identifier: 'LOCAL',
  },
];

export const getSiteIdentifier = () => {
  const si = siteIdentifiers.find((si) => window.location?.origin.includes(si.url));
  return si ? si.identifier + ' ' : '';
};

export const getDomain = () => {
  const domainName = window.location?.origin.includes('book.marriottvacationclub.asia ') ? 'asia' : 'me';
  return domainName;
};
